import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { searchDetailsClear } from './SearchDetails.actions';
import { AppState } from 'store';
import RecordedDocumentDetails from '../templates/RecordedDocumentDetails/RecordedDocumentDetails';
import { RecordedDocument, Lien } from '../models';
import LienDetails from '../templates/LienDetails/LienDetails';
import { BasicDrawer } from 'common';

const SearchDetails: React.FC<{ searchId: number }> = (props: {
  searchId: number;
}) => {
  const dispatch = useDispatch();
  const searchDetails = useSelector((state: AppState) => state.searchDetails);

  return (
    <BasicDrawer
      title={searchDetails.details?.documentTypeTitle}
      onBack={() => dispatch(searchDetailsClear())}
    >
      {searchDetails.details?.documentType === 'recordedDocuments' && (
        <RecordedDocumentDetails
          searchId={props.searchId}
          document={searchDetails.details as RecordedDocument}
        />
      )}
      {searchDetails.details?.documentType === 'uniformCommercialCodes' && (
        <RecordedDocumentDetails
          searchId={props.searchId}
          document={searchDetails.details as RecordedDocument}
        />
      )}
      {searchDetails.details?.documentType === 'federalTaxLiens' && (
        <RecordedDocumentDetails
          searchId={props.searchId}
          document={searchDetails.details as RecordedDocument}
        />
      )}
      {searchDetails.details?.documentType === 'liens' && (
        <LienDetails
          searchId={props.searchId}
          lien={searchDetails.details as Lien}
        />
      )}
    </BasicDrawer>
  );
};

export default SearchDetails;
